import { useInfiniteQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

interface Options {
	enabled?: boolean;
}

const getNextPageParam = ({ next }: CMSPaginatedData<StoreUser>) => {
	return next;
};

export const fetchUserByName = async (name?: string, nextPageUrl?: string) => {
	const url = nextPageUrl || `/store/user/?search=${name}&page=1`;

	const { data } = await cmsClient.get<CMSPaginatedData<StoreUser>>(url);

	return data;
};

const useStoreUser = (name?: string, options: Options = { enabled: true }) => {
	const query = useInfiniteQuery(
		["user", name],
		({ pageParam }) => fetchUserByName(name, pageParam),
		{
			getNextPageParam,
			enabled: options.enabled
		}
	);

	return query;
};

export default useStoreUser;
